<script>
	import {onMount} from 'svelte';
	import * as lib from './lib.js';

	onMount(async () => {
		lib.login();
	});

</script>

<main>
	<h1>Storymatcher</h1>
</main>

<style>
	main {
		text-align: center;
		padding: 1em;
		max-width: 1200px;
		margin: 0 auto;
	}

	h1 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 4rem;
		font-weight: 100;
	}

	h2 {
		color: #ff3e00;
		text-transform: uppercase;
		font-size: 2.45rem;
		font-weight: 100;
	}


	details {
		margin-bottom: 2rem;
	}

	details summary{
		display: block;
		font-size: 1.5rem;
		font-weight: 700;
		text-transform: uppercase;
		border: 3px solid #4741bf;
		color: #333;
		margin-bottom: 0;
		cursor: pointer;
	}

	.detailsWrapper {
		padding: 1rem;
		border-left: 1px solid #ccc;
		border-right: 1px solid #ccc;
		border-bottom: 1px solid #ccc;
	}


</style>
